import '@fancyapps/fancybox/dist/jquery.fancybox.min.js';
import 'flatpickr/dist/flatpickr.min.js';
import 'jquery.cookie';
import 'choices.js';

var events = {};

(function (eventsApp) {
	var filterModel = {
		Page: 1,
		SearchArea: "",
		SearchQuickDate: "",
		SearchArg: "",
		SearchCategory: "",
		SearchDateFrom: "",
		SearchDateTo: "",
		SearchCost: ""
	};
	const cookieName = "_oa_eventSearchParams";
	var pageType = $("#event-search-form").data("type");

	var fp = null;

	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];

			if (filterModel.Page) {
				queryArray.push("page=" + filterModel.Page);
			}
			if (filterModel.SearchArea) {
				queryArray.push("searchArea=" + filterModel.SearchArea);
			}
			if (filterModel.SearchQuickDate) {
				queryArray.push("searchQuickDate=" + filterModel.SearchQuickDate);
			}
			if (filterModel.SearchArg) {
				queryArray.push("searchArg=" + filterModel.SearchArg);
			}
			if (filterModel.SearchCategory) {
				queryArray.push("searchCategory=" + filterModel.SearchCategory);
			}
			if (filterModel.SearchDateFrom) {
				queryArray.push("searchDateFrom=" + filterModel.SearchDateFrom);
			}
			if (filterModel.SearchDateTo) {
				queryArray.push("searchDateTo=" + filterModel.SearchDateTo);
			}
			if (filterModel.SearchCost) {
				queryArray.push("searchCost=" + filterModel.SearchCost);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.Page = 1;
		filterModel.SearchArea = "";
		filterModel.SearchQuickDate = "";
		filterModel.SearchArg = "";
		filterModel.SearchCategory = "";
		filterModel.SearchDateFrom = "";
		filterModel.SearchDateTo = "";
		filterModel.SearchCost = "";
		eventsApp.setInputValue();

		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				if (key === "page") {
					filterModel.Page = val;
					eventsApp.setInputValue();
				} else if (key === "searchArea") {
					filterModel.SearchArea = val;
				} else if (key === "searchQuickDate") {
					filterModel.SearchQuickDate = val;
				} else if (key === "searchArg") {
					filterModel.SearchArg = val;
				} else if (key === "searchCategory") {
					filterModel.SearchCategory = val;
				} else if (key === "searchDateFrom") {
					filterModel.SearchDateFrom = val;
				} else if (key === "searchDateTo") {
					filterModel.SearchDateTo = val;
				} else if (key === "searchCost") {
					filterModel.SearchCost = val;
				}
				eventsApp.setInputValue();
			}
		}
		eventsApp.GetSearchResults();
	}

	eventsApp.setInputValue = function () {
		$("#searchArea").val(filterModel.SearchArea);
		$("#searchQuickDate").val(filterModel.SearchQuickDate);
		$('#searchArg').val(filterModel.SearchArg);
		$('#searchArgMobile').val(filterModel.SearchArg);

		$('#searchDateFrom').val(filterModel.SearchDateFrom);
		$('#searchDateTo').val(filterModel.SearchDateTo);
		$('#searchCost').val(filterModel.SearchCost);

		var hasCategory = filterModel.SearchCategory !== null && filterModel.SearchCategory !== "" && typeof filterModel.SearchCategory !== 'undefined';
		var hasDateFrom = filterModel.SearchDateFrom !== null && filterModel.SearchDateFrom !== "" && typeof filterModel.SearchDateFrom !== 'undefined';
		var hasDateTo = filterModel.SearchDateTo !== null && filterModel.SearchDateTo !== "" && typeof filterModel.SearchDateTo !== 'undefined';
		var hasCost = filterModel.SearchCost !== null && filterModel.SearchCost !== "" && typeof filterModel.SearchCost !== 'undefined';
		if (hasCategory || hasCost || hasDateFrom || hasDateTo) {
			$("#advanced-search").click();

			if (hasCategory) {
				//SearchCategory sometimes gets stored as an array of strings rather then a comma separated string.
				if (Array.isArray(filterModel.SearchCategory)) {
					filterModel.SearchCategory = filterModel.SearchCategory.join();
				}
				var choicesToSet = filterModel.SearchCategory.split(',');
				window.choices.setChoiceByValue(choicesToSet);
			}

			if (fp !== null && (hasDateFrom || hasDateTo)) {
				fp.setDate([filterModel.SearchDateFrom, filterModel.SearchDateTo]);
			}
		}
	};

	eventsApp.GetSearchResults = function () {
		$("body").css("cursor", "progress");

		$.ajax({
			url: "/umbraco/surface/EventSurface/GetSearchResults",
			data: filterModel,
			type: 'POST',
			cache: false,
			dataType: "html",
			success: function (data) {
				$('#events-wrapper').html($(data));
				$("body").css("cursor", "default");

				$([document.documentElement, document.body]).animate({
					scrollTop: $("#events-wrapper").offset().top - 200
				}, 200);

				if (window.initIsotope) {
					window.initIsotope();
				}

				pushHistory();
			},
			error: function (XMLHttpRequest, textStatus, errorThrown) {
				alert("An error has occurred making the request");
				$("body").css("cursor", "default");
			}
		});
	}

	$(document).ready(function () {
		if (window.initIsotope) {
			window.initIsotope();
		}

		//prevent fancybox triggering performSearchFromUrl() after window close
		$.fancybox.defaults.hash = false;

		fp = $('#filter-date-range').flatpickr({
			enableTime: false,
			altInput: true,
			altFormat: "d M Y",
			dateFormat: "Y-m-d",
			locale: {
				firstDayOfWeek: 1
			},
			mode: "range",
			minDate: "today",
			disableMobile: "true",
			onChange: function (selectedDates, dateStr, instance) {
				if (selectedDates && selectedDates.length == 2) {
					$("#searchDateFrom").val(flatpickr.formatDate(selectedDates[0], "Y-m-d"));
					$("#searchDateTo").val(flatpickr.formatDate(selectedDates[1], "Y-m-d"));
					instance.close();

					//reset quickdate value
					$("#searchQuickDate").val("");
				}
			}
		});

		//check if querystring params exist on load/reload
		const urlParams = new URLSearchParams(window.location.search);
		var hasQueryString = urlParams.has('page') || urlParams.has('searchArea') || urlParams.has('searchQuickDate') || urlParams.has('searchArg') ||
			urlParams.has('searchCategory') || urlParams.has('searchDateFrom') || urlParams.has('searchDateTo') || urlParams.has('searchCost');

		if (hasQueryString) {

			if (urlParams.get('page')) {
				filterModel.Page = urlParams.get('page');
			}
			if (urlParams.get('searchArea')) {
				filterModel.SearchArea = urlParams.get('searchArea');
			}
			if (urlParams.get('searchQuickDate')) {
				filterModel.SearchQuickDate = urlParams.get('searchQuickDate');
			}
			if (urlParams.get('searchArg')) {
				filterModel.SearchArg = urlParams.get('searchArg');
			}
			if (urlParams.get('searchCategory')) {
				filterModel.SearchCategory = urlParams.get('searchCategory');
			}
			if (urlParams.get('searchDateFrom')) {
				filterModel.SearchDateFrom = urlParams.get('searchDateFrom');
			}
			if (urlParams.get('searchDateTo')) {
				filterModel.SearchDateTo = urlParams.get('searchDateTo');
			}
			if (urlParams.get('searchCost')) {
				filterModel.SearchCost = urlParams.get('searchCost');
			}

			eventsApp.setInputValue();

			setCookie();

		} else {
			if (pageType === "eventsLanding") {
				removeCookie();
			}

			// get params saved in cookie 
			var cookieValue = null;
			if (typeof $.cookie(cookieName) !== 'undefined') {
				cookieValue = JSON.parse($.cookie(cookieName));
			}

			if (cookieValue) {
				if (cookieValue.Page) {
					filterModel.Page = cookieValue.Page;
				}
				if (cookieValue.SearchArea) {
					filterModel.SearchArea = cookieValue.SearchArea;
				}
				if (cookieValue.SearchQuickDate) {
					filterModel.SearchQuickDate = cookieValue.SearchQuickDate;
				}
				if (cookieValue.SearchArg) {
					filterModel.SearchArg = cookieValue.SearchArg;
				}
				if (cookieValue.SearchCategory) {
					filterModel.SearchCategory = cookieValue.SearchCategory;
				}
				if (cookieValue.SearchDateFrom) {
					filterModel.SearchDateFrom = cookieValue.SearchDateFrom;
				}
				if (cookieValue.SearchDateTo) {
					filterModel.SearchDateTo = cookieValue.SearchDateTo;
				}
				if (cookieValue.SearchCost) {
					filterModel.SearchCost = cookieValue.SearchCost;
				}
			}

			eventsApp.setInputValue();
			removeCookie();
		}

		
		$(document).on("submit", "#event-search-form", function (e) {
			checkPageType(e);
			setCookie();
		});

		function setCookie() {
			var date = new Date();
			var minutes = 1;
			date.setTime(date.getTime() + (minutes * 60 * 1000));
			$.cookie(cookieName, JSON.stringify(filterModel), { expires: date, path: '/' });
		}

		function removeCookie() {
			$.cookie(cookieName, null, { path: '/' });
		}

		function checkPageType(e) {
			// check if on event or event landing page (eventsLanding)
			if (pageType === "eventsLanding") {
				e.preventDefault();
				getFilterValues();
			}
			//else do nothing and allow form to submit to event landing page
		}

		function getFilterValues() {
			var isAdvancedSearch = $('#advanced-search').hasClass('is-active');

			filterModel.Page = 1;
			filterModel.SearchArea = $("#searchArea option:selected").val();
			filterModel.SearchQuickDate = $("#searchQuickDate option:selected").val();
			filterModel.SearchArg = $('#searchArg').val();
			filterModel.SearchCategory = isAdvancedSearch ? $('#searchCategory').val() : null;
			filterModel.SearchDateFrom = isAdvancedSearch ? $('#searchDateFrom').val() : null;
			filterModel.SearchDateTo = isAdvancedSearch ? $('#searchDateTo').val() : null;
			filterModel.SearchCost = isAdvancedSearch ? $('#searchCost').val() : null;

			eventsApp.GetSearchResults();
		}


		//on pagination click event
		$(document).on('click', 'ul.pagination a', function (e) {
			e.preventDefault();
			filterModel.Page = $(this).data('page');
			setCookie();
			eventsApp.GetSearchResults();
		});


		// copy searchArgMobile text to searchArg field
		$("#searchArgMobile").on("keyup paste", function () {
			$("#searchArg").val($(this).val());
		});

		//on show more click event detail panel
		$(document).on('click', '.event-panel a.show-more-link', function (e) {
			e.preventDefault();
			const wasOpen = $(this).data("open");
			$(this).closest('.event-panel__group').find('.js-hidden-sessions,.js-hidden-tags').toggle();
			$(this).text(wasOpen ? "Show More" : "Show Less");
			$(this).data("open", !wasOpen);
		});
	});

})(events);
